var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_11894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.97 2H8.96997C3.96997 2 1.96997 4 1.96997 9V15C1.96997 20 3.96997 22 8.96997 22H14.97C19.97 22 21.97 20 21.97 15V13",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8799 3.56022C20.6499 6.63022 17.5599 10.8102 14.9799 12.8802L13.3999 14.1402C13.1999 14.2902 12.9999 14.4102 12.7699 14.5002C12.7699 14.3502 12.7599 14.2002 12.7399 14.0402C12.6499 13.3702 12.3499 12.7402 11.8099 12.2102C11.2599 11.6602 10.5999 11.3502 9.91994 11.2602C9.75994 11.2502 9.59994 11.2402 9.43994 11.2502C9.52994 11.0002 9.65994 10.7702 9.82994 10.5802L11.0899 9.00022C13.1599 6.42022 17.3499 3.31022 20.4099 2.08022C20.8799 1.90022 21.3399 2.04022 21.6299 2.33022C21.9299 2.63022 22.0699 3.09022 21.8799 3.56022Z",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7801 14.4905C12.7801 15.3705 12.4401 16.2105 11.8101 16.8505C11.3201 17.3405 10.6601 17.6805 9.87009 17.7805L7.90009 17.9905C6.83009 18.1105 5.91009 17.2005 6.03009 16.1105L6.24009 14.1405C6.43009 12.3905 7.89009 11.2705 9.45009 11.2405C9.61009 11.2305 9.77009 11.2405 9.93009 11.2505C10.6101 11.3405 11.2701 11.6505 11.8201 12.2005C12.3601 12.7405 12.6601 13.3605 12.7501 14.0305C12.7701 14.1905 12.7801 14.3505 12.7801 14.4905Z",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.82 11.9795C15.82 9.88945 14.13 8.18945 12.03 8.18945",
    stroke: "#686868",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_11894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicpen);
export default __webpack_public_path__ + "static/media/magicpen.4090575c9492fc7f7f170c0b470bb621.svg";
export { ForwardRef as ReactComponent };